/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMonetaryListItem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2zm2 2v4h16V4zm0 6v4h16v-4zm0 6v4h16v-4zm9-9H6V5h7zm5 0h-2V5h2zm-5 6H6v-2h7zm5 0h-2v-2h2zm-5 6H6v-2h7zm5 0h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMonetaryListItem as MonetaryListItem };
